import { Component, Inject, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-problem-devices-modal',
  standalone: false,
  templateUrl: './problem-devices-modal.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./problem-devices-modal.component.css']
})
export class ProblemDevicesModalComponent implements OnInit, OnDestroy {
  now: number = Date.now();
  private intervalId: ReturnType<typeof setInterval>;

  readonly i18n = {
    title: { en: 'Problem Devices', sv: 'Problemenheter' },
    noDevices: { en: 'No problem devices', sv: 'Inga problemenheter' },
    offline: { en: 'Offline', sv: 'Frånkopplad' },
    close: { en: 'Close', sv: 'Stäng' },
    onlineFor: { en: 'Online for', sv: 'Online i' },
    min: { en: 'min', sv: 'min' },
  };

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: {
      problemDevices: any[]
    },
    private dialogRef: MatDialogRef<ProblemDevicesModalComponent>
  ) { }

  ngOnInit(): void {
    this.intervalId = setInterval(() => this.now = Date.now(), 1000 * 30);
  }

  ngOnDestroy(): void {
    clearInterval(this.intervalId);
  }

  onlineSinceMinutesAgo(device: any): number | null {
    if (!device.onlineSinceUtc) {
      return null;
    }
    const minutes = (this.now - new Date(device.onlineSinceUtc).getTime()) / 60000;
    return Math.max(0, Math.round(minutes));
  }

  closeDialog(): void {
    this.dialogRef.close();
  }
}
